// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"8888d5cd","428":"d7100de3","838":"f7bc272f","894":"165d91b1"}[chunkId] + ".chunk.js";
};